/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderModel } from './OrderModel';
import {
    OrderModelFromJSON,
    OrderModelFromJSONTyped,
    OrderModelToJSON,
} from './OrderModel';

/**
 * 
 * @export
 * @interface OrderReturnModel
 */
export interface OrderReturnModel {
    /**
     * 
     * @type {OrderModel}
     * @memberof OrderReturnModel
     */
    order?: OrderModel;
    /**
     * 
     * @type {boolean}
     * @memberof OrderReturnModel
     */
    isTracked?: boolean;
}

/**
 * Check if a given object implements the OrderReturnModel interface.
 */
export function instanceOfOrderReturnModel(value: object): boolean {
    return true;
}

export function OrderReturnModelFromJSON(json: any): OrderReturnModel {
    return OrderReturnModelFromJSONTyped(json, false);
}

export function OrderReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'order': json['order'] == null ? undefined : OrderModelFromJSON(json['order']),
        'isTracked': json['isTracked'] == null ? undefined : json['isTracked'],
    };
}

export function OrderReturnModelToJSON(value?: OrderReturnModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'order': OrderModelToJSON(value['order']),
        'isTracked': value['isTracked'],
    };
}

